import React, {FunctionComponent} from "react";
import {ActionFieldProps} from "../../features/actions/common/commonTypes";
import {SubtleTextbox} from "./SubtleTextBox";
import {harvestErrors} from "./SubtleTextBox";

const HostInput: FunctionComponent<ActionFieldProps> = (
    {
        formState,
        resetField,
        validatingRegister,
        mutationResults
    }
) => {
    return <SubtleTextbox
        {...validatingRegister('host')}
        showLabel
        key="host"
        label="Host"
        isDirty={Boolean(formState.dirtyFields.host)}
        onReset={() => resetField('host')}
        error={harvestErrors(
            'host',
            formState,
            mutationResults
        )}
    />;
}

export default HostInput;
